/**
 * Conversiile din formularul de plata noua.
 *
 * Stau separat de componenta pentru acelasi motiv ca `filtre.ts`: sunt functii pure cu cazuri
 * limita reale (separator zecimal, scara monedei), iar un test pe ele nu are nevoie de DOM.
 *
 * Ambele traduc din „ce a tastat omul" in „ce intelege serverul", si niciuna nu rotunjeste bani:
 * `parseAmountInput` din `@evomag/core/money` rămâne singurul loc din aplicatie unde o suma devine
 * unitati minore.
 */

/**
 * Cursul, in unitati x1e6.
 *
 * `,` si `.` sunt AMANDOUA separator zecimal, ca peste tot in aplicatie: cine tasteaza pe blocul
 * numeric scrie `5.26`, cine tasteaza pe randul de sus scrie `5,26`, si amandoi au dreptate.
 * Orice altceva intoarce `null` — un curs pe jumatate citit ar inmulti o suma cu o cifra gresita,
 * deci refuzul e singurul raspuns corect.
 */
export function citesteCurs(text: string): number | null {
  const curat = text.trim().replace(/\s/g, '').replace(',', '.');
  if (curat === '') return null;
  if (!/^\d+(\.\d+)?$/.test(curat)) return null;
  const valoare = Number(curat);
  if (!Number.isFinite(valoare) || valoare <= 0) return null;
  return Math.round(valoare * 1_000_000);
}

/**
 * Text canonic pentru o suma deja parsata, ca serverul sa reparseze EXACT aceeasi valoare.
 *
 * Se trimite text, nu cifra in unitati minore, pentru ca ruta primeste acelasi `AmountInput` ca
 * editarea inline — un singur parser pe server, nu doi. Formatul e deliberat neutru (punct zecimal,
 * fara separator de mii): trece prin `parseAmountInput` fara ambiguitate, indiferent de locale.
 */
export function textDinMinor(minor: number, scalaMinora: number): string {
  if (scalaMinora <= 1) return String(minor);
  const semn = minor < 0 ? '-' : '';
  const absolut = Math.abs(minor);
  const cifreZecimale = String(scalaMinora).length - 1;
  const intreg = Math.trunc(absolut / scalaMinora);
  const zecimale = String(absolut % scalaMinora).padStart(cifreZecimale, '0');
  return `${semn}${intreg}.${zecimale}`;
}
